import React, { useEffect, useRef, useState } from 'react'
import DateRangePicker from '../../../../components/DataRangePicker'
import { calculateDateRange } from '../../../../utils/dateUtils';

function DashboardDataRange({onChange = () => {}, dateRange}) {
  const boxRef = useRef(null);
  const [isDateRangeOpen, setDateRangeOpen] = useState(false);
  const [selectedDataRange, setSelectedDataRange] = useState({
    start: new Date(),
    end : new Date()
  }) 

  useEffect(() => {
    if (dateRange) {
      const { start, end } = calculateDateRange(dateRange);
      setSelectedDataRange({ start, end });
    }
  }, [dateRange]);

  const toggleDataRange = () => {
    setDateRangeOpen((prev) => !prev);
  }
  const handleDateRangeClick = (selectedRange) => {
    // Alternar el estado del selector de rango de fechas
    setDateRangeOpen((prev) => !prev);
    const { start, end } = calculateDateRange(selectedRange);
    setSelectedDataRange({ start, end });
    console.log(selectedRange)
    onChange(selectedRange);
  };

  const handleClickOutside = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setDateRangeOpen(false);
    }
  };
  
  useEffect(() => {
    if (isDateRangeOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDateRangeOpen]);

  return (
    <div className='relative cursor-pointer' >
      <div className='border-b-2 w-96 text-center basis-1/3' onClick={toggleDataRange}>
        <span className=' my-auto '  >{selectedDataRange.start.toLocaleDateString()} - {selectedDataRange.end.toLocaleDateString()}</span>
      </div>
      {isDateRangeOpen && (
        <div className=" absolute z-50 -left-1/3 mt-2 w-[40rem] bg-white border border-gray-300 rounded shadow-lg">
          <DateRangePicker
            onChange={(selectedRange) => { handleDateRangeClick(selectedRange)}}
            closeWindow={() => setDateRangeOpen(false)}
            options={dateRange} 
          />
        </div>
      )}
      
    </div>
  )
}

export default DashboardDataRange